document.addEventListener("DOMContentLoaded", () => {
  const DESKTOP_LOAD_MORE_COUNT = 4;
  const MOBILE_LOAD_MORE_COUNT = 5;
  const DESKTOP_INITIAL_COUNT = 7;
  const MOBILE_INITIAL_COUNT = 5;
  const dataBlogCursors = {};
  const authorSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path d="M11.333 8.701l-7.837 4.262s-1.339 5.254-3.497 8.604l2.419 2.433c3.314-2.133 8.604-3.511 8.604-3.511l4.263-7.837-3.952-3.951zm-1.664 10.091c-1.241.365-3.64 1.131-5.915 2.207l1.806-1.806c.348-.349.8-.569 1.288-.63.647-.081 1.113-.63 1.113-1.263 0-.703-.569-1.275-1.275-1.275-.637 0-1.183.471-1.263 1.113-.06.487-.281.94-.629 1.288l-1.779 1.779c1.072-2.274 1.825-4.652 2.184-5.891l5.778-3.143 1.838 1.837-3.146 5.784zm2.345-12.252s2.148-3.969 3.475-6.54l8.511 8.511c-2.582 1.321-6.556 3.459-6.556 3.459l-5.43-5.43z"/></svg>`;
  const readingTimeSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path d="M18.513 7.119c.958-1.143 1.487-2.577 1.487-4.036v-3.083h-16v3.083c0 1.459.528 2.892 1.487 4.035l3.086 3.68c.567.677.571 1.625.009 2.306l-3.13 3.794c-.936 1.136-1.452 2.555-1.452 3.995v3.107h16v-3.107c0-1.44-.517-2.858-1.453-3.994l-3.13-3.794c-.562-.681-.558-1.629.009-2.306l3.087-3.68zm-4.639 7.257l3.13 3.794c.652.792.996 1.726.996 2.83h-1.061c-.793-2.017-4.939-5-4.939-5s-4.147 2.983-4.94 5h-1.06c0-1.104.343-2.039.996-2.829l3.129-3.793c1.167-1.414 1.159-3.459-.019-4.864l-3.086-3.681c-.66-.785-1.02-1.736-1.02-2.834h12c0 1.101-.363 2.05-1.02 2.834l-3.087 3.68c-1.177 1.405-1.185 3.451-.019 4.863z"/></svg>`;
  let isRemainingFetchStarted = false;
  const blogHandle =
    document.querySelector("[data-blog-handle]").dataset.blogHandle;
  let articleData = [];
  const handles = document.querySelectorAll(
    ".backyard-blog-cards[data-tagged='false'] .handle"
  );
  handles.forEach((handle) => {
    handle.addEventListener("click", handleAccordionButtonClick);
  });
  const loadMoreButtons = document.querySelectorAll(
    ".backyard-cards-button-container button"
  );

  loadMoreButtons.forEach((button) => {
    button.addEventListener("click", handleLoadMoreButton);
  });

  // FUNCTIONS

  function handleAccordionButtonClick(e) {
    const container = e.target.closest(".backyard-blog-cards");
    const openedCard = document.querySelector(
      ".backyard-blog-cards[data-content-opened='true']"
    );
    if (openedCard && openedCard != container) {
      openedCard.dataset.contentOpened = "false";
    }

    const isOpened = container.dataset.contentOpened === "true";
    if (isOpened) {
      closeBlogCards(container);
    } else {
      openBlogCards(container);
    }
  }

  function openBlogCards(container) {
    container.dataset.contentOpened = "true";
    const offsetTop =
      container.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: offsetTop - 100,
      behavior: "smooth",
    });
  }
  function closeBlogCards(container) {
    container.dataset.contentOpened = "false";
  }

  async function handleLoadMoreButton(e) {
    if (isRemainingFetchStarted) return;
    const cardWrapper =
      e.target.closest(".article-cards-wrapper") ||
      e.target.closest(".backyard-desktop-wrapper .bottom-layout-wrapper");
    const buttonContainer = cardWrapper.querySelector(
      ".backyard-cards-button-container"
    );
    const isDesktop = buttonContainer.classList.contains("desktop");
    const cards = cardWrapper.querySelectorAll(".backyard-article-card");
    const tag = cardWrapper.dataset.tag;
    const breakpointKey = isDesktop ? "desktop" : "mobile";
    if (!dataBlogCursors[tag]) {
      dataBlogCursors[tag] = { desktop: null, mobile: null };
    }
    const prevCursor = dataBlogCursors[tag][breakpointKey];
    buttonContainer.querySelector("button").classList.add("loading");
    isRemainingFetchStarted = true;
    if (prevCursor === null) {
      const cursor = await getCategoryCursor(
        isDesktop ? DESKTOP_INITIAL_COUNT : MOBILE_INITIAL_COUNT,
        tag
      );
      dataBlogCursors[tag][breakpointKey] = cursor;
    }

    const { articles, hasNextPage, nextCursor } = await getArticles(
      tag,
      dataBlogCursors[tag][breakpointKey],
      isDesktop ? DESKTOP_LOAD_MORE_COUNT : MOBILE_LOAD_MORE_COUNT
    );
    if (hasNextPage) {
      dataBlogCursors[tag][breakpointKey] = nextCursor;
    } else {
      buttonContainer.style.display = "none";
    }
    articles.forEach((article, i) => {
      const articleCard = createNewArticleCard(article);
      if (isDesktop) {
        if (i != 0) articleCard.classList.add("border-left");
        articleCard.classList.remove("image_left");
        articleCard.classList.add("image_top");
      }
      cardWrapper.insertBefore(articleCard, buttonContainer);
    });
    buttonContainer.querySelector("button").classList.remove("loading");
    isRemainingFetchStarted = false;
  }

  function createNewArticleCard(article) {
    const articleCardToCopy = document.querySelector(
      ".backyard-article-card.image_left"
    );
    const clonedArticleCard = articleCardToCopy.cloneNode(true);
    const articleUrl = new URL(article.onlineStoreUrl).pathname;
    clonedArticleCard.dataset.articleId = article.id;
    clonedArticleCard.href = articleUrl;

    const cardImage = clonedArticleCard.querySelector(
      ".article-image-container img"
    );
    cardImage.srcset = "";
    cardImage.src = article.image.src;

    const cardTitle = clonedArticleCard.querySelector(
      ".article-card-content .article-title"
    );
    cardTitle.textContent = article.title;

    const cardTagsAndDate = clonedArticleCard.querySelector(".tags-and-date");
    cardTagsAndDate.innerHTML = "";
    article.tags.forEach((tag) => {
      cardTagsAndDate.insertAdjacentHTML(
        "beforeend",
        `<div class="tag">${tag}</div>`
      );
    });

    const options = { month: "short", day: "numeric", year: "numeric" };
    const formattedDate = new Date(article.publishedAt).toLocaleDateString(
      "en-US",
      options
    );

    cardTagsAndDate.insertAdjacentHTML(
      "beforeend",
      `<div class="date"><time datetime="${article.publishedAt}">${formattedDate}</time></div>`
    );

    const authorContainer = clonedArticleCard.querySelector(".author");
    authorContainer.innerHTML = authorSVG + article.author.name;

    const readingTimeContainer =
      clonedArticleCard.querySelector(".reading-time");

    const readingTimeInMinutes = calculateReadingTime(article.content);
    readingTimeContainer.innerHTML = `${readingTimeSVG} ${readingTimeInMinutes} Min Read`;

    const excerptContainer = clonedArticleCard.querySelector(".excerpt");
    excerptContainer.textContent = article.excerpt;

    return clonedArticleCard;
  }

  function calculateReadingTime(articleContent) {
    const wordsPerMinute = 200;
    const textContent = articleContent.replace(/<[^>]*>/g, "");
    const wordCount = Math.ceil(textContent.length / 7);
    const readingTimeMinutes = Math.ceil(wordCount / wordsPerMinute);
    if (readingTimeMinutes === 1) return 2;
    return readingTimeMinutes;
  }

  function extractId(text) {
    const matches = text.match(/\/(\d+)$/);
    if (matches) {
      const match = matches[1];
      return match;
    }
    return null;
  }

  const endpoint = `/api/2025-07/graphql`;
  const headers = {
    "Content-Type": "application/json",
    "X-Shopify-Storefront-Access-Token": "e2b8204a109288f04a6e9fe359f0a2f8",
    "Accept-Language": localeHandle, // localeHandle -> in blog-template-scripts.liquid
  };

  async function getArticles(tag, startIndex = null, count) {
    const afterCursor = startIndex ? `"${startIndex}"` : "null";
    const query = `
    {
      blogByHandle(handle: "${blogHandle}") {
        articles(first: ${count}, after: ${afterCursor}, sortKey: PUBLISHED_AT, reverse: true, query:"tag:${tag}") {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              title
              excerpt
              publishedAt
              content
              image {
                src
                altText
              }
              author {
                name
              }
              tags
              onlineStoreUrl
            }
          }
        }
      }
    }
  `;

    const response = await fetch(endpoint, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ query }),
    });

    const data = await response.json();
    // console.log("data ---->", data);

    const articles = data.data.blogByHandle.articles.edges.map((edge) => {
      return { ...edge.node, id: extractId(edge.node.id) };
    });

    return {
      articles,
      nextCursor: data.data.blogByHandle.articles.pageInfo.endCursor,
      hasNextPage: data.data.blogByHandle.articles.pageInfo.hasNextPage,
    };
  }

  async function getCategoryCursor(count, tag) {
    // console.log(count, tag);
    const query = `
     {
      blogByHandle(handle: "${blogHandle}") {
        articles(first: ${count}, sortKey: PUBLISHED_AT, reverse: true, query:"tag:${tag}") {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
            }
          }
        }
      }
    }`;
    const response = await fetch(endpoint, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ query }),
    });
    const data = await response.json();

    return data.data.blogByHandle.articles.pageInfo.endCursor;
  }
});
